import React from 'react';
import { RecentlyViewedProductT } from '@lambda/apis/src/dynamoDb/types';
import RecentlyViewedSlider from './RecentlyViewedSlider';
import Section from '../commons/Section';

export default function RecentlyViewed({
  recentlyViewed,
  fetching,
  isHomepage,
  isAccount,
}: {
  recentlyViewed: RecentlyViewedProductT[];
  fetching: boolean;
  isHomepage?: boolean;
  isAccount?: boolean;
}) {
  const config = {
    title: 'Recently Viewed',
  };

  if (recentlyViewed.length > 1) {
    return (
      <Section className="py-8">
        <RecentlyViewedSlider
          title={config.title}
          products={recentlyViewed}
          fetching={fetching}
          isHomepage={isHomepage}
          isAccount={isAccount}
        />
      </Section>
    );
  }

  return null;
}
